/**
 * SEOHead - React 19 native document metadata
 * 
 * React 19 supports rendering <title>, <meta>, and <link> tags directly
 * in components - they automatically hoist to <head>.
 */

interface SEOHeadProps {
  title: string;
  description?: string;
  canonicalUrl?: string;
  ogImage?: string;
}

const DEFAULT_DESCRIPTION = 'Start your fitness journey grounded in accountability. AI trainers who guide your workouts and hold you accountable via SMS and phone calls.';
const DEFAULT_CANONICAL_URL = 'https://startgrounded.com';
const DEFAULT_OG_IMAGE = 'https://startgrounded.com/og-image.png';

export function SEOHead({
  title,
  description = DEFAULT_DESCRIPTION,
  canonicalUrl = DEFAULT_CANONICAL_URL,
  ogImage = DEFAULT_OG_IMAGE,
}: SEOHeadProps) {
  return (
    <>
      {/* Basic meta tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      
      {/* Open Graph / Social Media */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content="Start Grounded" />
      <meta property="og:url" content={canonicalUrl} />
      
      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      <meta name="twitter:creator" content="@startgrounded" />
      
      {/* Canonical URL */}
      <link rel="canonical" href={canonicalUrl} />
    </>
  );
}

export default SEOHead;
